import { render, staticRenderFns } from "./ti2.vue?vue&type=template&id=d5577c0c&scoped=true&"
import script from "./ti2.vue?vue&type=script&lang=js&"
export * from "./ti2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5577c0c",
  null
  
)

export default component.exports